import React, { FC } from 'react';

import ExperienceBlocked from 'src/components/challenge/consumer/ExperienceBlocked';
import { IRootReducers } from 'src/reducers';
import { IChallengeResourceRender, IHiddenItem } from 'src/shared/models';

interface Props extends IChallengeResourceRender {
  config: IHiddenItem;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
  };
};

type OwnProps = ReturnType<typeof mapStateToProps> & Props;

const ChallengeHidden: FC<OwnProps> = ({ config, user }) => {
  return <ExperienceBlocked user={user} {...config} />;
};

export default ChallengeHidden;
